module.exports = __webpack_public_path__ + "img/catalog_guide.e00ed423.svg";